import ExecuteApiCall from './apiClient';

export function fetchProducts() {
  return ExecuteApiCall('get', 'api/v3/shopify/products');
}
